module.exports = new __parcel__URL__("sentence-boundary-detection.cb74a56f.png").toString();